import React, { useEffect, useRef, useState } from "react";
import { Chart, registerables } from "chart.js";
import BASE_URL from "components/BaseUrl/apiConfig";

// Register Chart.js components
Chart.register(...registerables);

const ExpByWeekOfYear = () => {
  const chartRef = useRef(null);
  const [currency, setCurrency] = useState("");
  const storedUserData = localStorage.getItem("userData");
  let userId = "";
  let groupId = "";

  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    groupId = userData.groupId;
  }

  useEffect(() => {
    const fetchCurrencyData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Users/GetCurrencyByUserId?groupId=${groupId}`
        );
        const data = await response.json();
        setCurrency(data.currency);
      } catch (error) {
        console.error("Error fetching currency data:", error);
      }
    };

    fetchCurrencyData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://localhost:7208/api/Analytics/GetExpensesByWeek?groupId=16&year=2024"
        );
        const data = await response.json();

        const labels = data.map(
          (item) => `${item.weekStartDate} - ${item.weekEndDate}`
        );
        const totalCredit = data.map((item) => item.totalCredit);
        const totalDebit = data.map((item) => item.totalDebit * -1);

        if (chartRef.current) {
          new Chart(chartRef.current, {
            type: "line",
            data: {
              labels: labels,
              datasets: [
                {
                  label: "Total Credit",
                  data: totalCredit,
                  borderColor: "rgba(75, 192, 192, 1)",
                  backgroundColor: "rgba(75, 192, 192, 0.2)",
                  pointBackgroundColor: "rgba(75, 192, 192, 1)",
                  pointRadius: 6,
                  pointHoverRadius: 8,
                  tension: 0.1,
                },
                {
                  label: "Total Debit",
                  data: totalDebit,
                  borderColor: "rgba(255, 99, 132, 1)",
                  backgroundColor: "rgba(255, 99, 132, 0.2)",
                  pointBackgroundColor: "rgba(255, 99, 132, 1)",
                  pointRadius: 6,
                  pointHoverRadius: 8,
                  tension: 0.1,
                },
              ],
            },
            options: {
              responsive: true,
              plugins: {
                title: {
                  display: true,
                },
              },
              scales: {
                x: {
                  beginAtZero: true,
                  ticks: {
                    maxRotation: 90,
                    minRotation: 90,
                  },
                  title: {
                    display: true,
                    text: "Weeks",
                  },
                },
                y: {
                  beginAtZero: false,
                  suggestedMin: Math.min(...totalCredit, ...totalDebit) - 5,
                  suggestedMax: Math.max(...totalCredit) + 5,
                  ticks: {
                    stepSize: 0.5,
                    callback: function (value) {
                      return value.toFixed(2);
                    },
                  },
                  title: {
                    display: true,
                    text: `Amount (${currency})`,
                  },
                },
              },
            },
          });
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [currency]);

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
        <div className="rounded mr-4 pl-4 mt-4 bg-transparent">
          <div className="flex flex-wrap items-center">
            <div className="relative w-full max-w-full flex-grow flex-1">
              <h2 className="text-blueGray-700 text-xl font-semibold">
                Weeks wise Expenses ({currency})
              </h2>
              <div className="relative" style={{ height: "700px" }}>
                <canvas
                  ref={chartRef}
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ExpByWeekOfYear;
